var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"text"},[_c('h1',[_vm._v("服务网络")]),_c('div',[_c('p',[_vm._v(" 宁明软件业务覆盖全国大多数省市区域，形成了以长江三角洲为中心辐射全国的运营服务体系。 ")])])])])
}]

export { render, staticRenderFns }